
























import { Component, Vue, Watch } from "@/shared/vuepack";
import AuthorizedSigners from "@/employee/components/settings/AuthorizedSigners.vue";
import Beneficiaries from "@/employee/components/settings/Beneficiaries.vue";

@Component({
  components: {
    AuthorizedSigners,
    Beneficiaries,
  }
})
export default class AccountInfoTabs extends Vue {
  showBeneficiaries = false;
  showAuthorizedSigners = true;

  authorizedSignersTabClicked () {
    this.showAuthorizedSigners = true;
    this.showBeneficiaries = false;
  }

  beneficiariesTabClicked () {
    this.showAuthorizedSigners = false;
    this.showBeneficiaries = true;
  }
}
